export default __webpack_public_path__ + "static/N0074-ee78341eb2463f116e9293096b1a4012.png";